import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getCompanyMSContactListData } from './mockData'
import type { ICompanyMSContact } from '@/types/company/models'

interface GetCompanyMSContactsResponse {
  data: ICompanyMSContact[] | undefined
}

const postCompanyMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getCompanyMSContactListData)
}

const patchCompanyMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getCompanyMSContactListData)
}

const deleteCompanyMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getCompanyMSContactListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/companymscontacts',
    handler: postCompanyMSContact,
  },
  {
    method: 'patch',
    path: '/api/companymscontacts/:id',
    handler: patchCompanyMSContact,
  },
  {
    method: 'delete',
    path: '/api/companymscontacts/:id',
    handler: deleteCompanyMSContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
